import { sensorIconLabelLayer, sensorIconLayer } from '@components/map/layers/sensors/sensor.layer';
import { SHOW_PERIMETER_SENSOR_MIN_ZOOM } from '@utils/map/mapZoom.constants';
import { LineLayerSpecification, SymbolLayerSpecification } from 'mapbox-gl';

import { FeatureTypeEnum, LayerNameEnum, SourceNameEnum } from '@/types/map.types';

export const perimeterSensorIconLayer: SymbolLayerSpecification = {
  ...sensorIconLayer,
  id: LayerNameEnum.PERIMETER_SENSOR_ICONS,
  source: SourceNameEnum.PERIMETER_SENSORS,
  minzoom: SHOW_PERIMETER_SENSOR_MIN_ZOOM,
};

export const perimeterSensorIconLabelLayer: SymbolLayerSpecification = {
  ...sensorIconLabelLayer,
  id: LayerNameEnum.PERIMETER_SENSOR_LABELS,
  source: SourceNameEnum.PERIMETER_SENSORS,
  minzoom: SHOW_PERIMETER_SENSOR_MIN_ZOOM,
};

export const perimeterLinkLayer: LineLayerSpecification = {
  id: LayerNameEnum.PERIMETER_LINKS,
  type: 'line',
  source: SourceNameEnum.PERIMETER_SENSORS,
  filter: ['==', 'featureType', FeatureTypeEnum.PERIMETER_LINK],
  minzoom: SHOW_PERIMETER_SENSOR_MIN_ZOOM,
  paint: {
    'line-color': 'white',
    'line-width': 2,
  },
};

export const perimeterLinkOutlineLayer: LineLayerSpecification = {
  ...perimeterLinkLayer,
  id: LayerNameEnum.PERIMETER_LINK_OUTLINES,
  paint: {
    'line-color': 'black',
    'line-width': 4,
  },
};
